/* eslint-disable react-hooks/exhaustive-deps */
import { Button, message, Modal, Select, Input, Form, } from 'antd';

import { useEffect, useState } from 'react';
import API from '../../../services/API';
import LoaderComponent from '../../Loader';

const { Option } = Select;
function UploadSillaDocument({ showAddDocumentModal, closeDocumentModal, userId }) {
  const [modalLoading, setModalLoading] = useState(false);
  const [documentTypes, setDocumentTypes] = useState([]);
  const [fileToUpload, setFileToUpload] = useState(null);
  const [form] = Form.useForm();

  const loadDocumentTypes = async () => {
    try {
      setModalLoading(true);
      const res = await API.getDocumentTypes();
      const documentTypes = res.documentTypes;
      setDocumentTypes(documentTypes);
    } catch (e) {
      message.error(e.message);
    } finally {
      setModalLoading(false);
    }
  }

  useEffect(() => {
    loadDocumentTypes();
  }, []);

  const closeModal = async (updated) => {
    await form.resetFields()
    setFileToUpload(null);
    closeDocumentModal(updated);
  }

  const uploadDocument = async (values) => {
    try {
      setModalLoading(true);
      let res = await API.uploadDocument(userId, values.docType, values.description, fileToUpload);
      closeModal(true);
      message.success(res.successMessage);
    } catch (e) {
      message.error(e.message);
    } finally {
      closeModal(false);
      setModalLoading(false);
    }
  }

  const triggerSubmitBtn = async () => {
    await form.validateFields();
    document.getElementById("upload-document").click();
  };

  return (
    <Modal
      title={'Upload document'}
      centered
      mask={true}
      maskClosable={true}
      okText={'Upload'}
      destroyOnClose={true}
      okButtonProps={{
      }
      }
      closable={true}
      visible={showAddDocumentModal}
      onOk={triggerSubmitBtn}
      onCancel={() => closeModal(false)}
      className="confirm-modal"
    >
      {!modalLoading &&
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={uploadDocument}
          form={form}
          onFinishFailed={() => closeModal(false)}
          autoComplete="off"
        >

          <Form.Item
            label="Document Type"
            name="docType"
            rules={[
              {
                required: true,
                message: "Document type is required!",
              },
            ]}
          >
            <Select placeholder={"Please select document type"}
              style={{ minWidth: 200 }}>
              {documentTypes && documentTypes.map((doc) => {
                return <Option key={doc.name} value={doc.name}>{doc.label}</Option>
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Description"
            name="description"
            rules={[
              {
                required: false,
              },
            ]}
          >
            <Input
              placeholder="Description"
            />
          </Form.Item>
          <Form.Item
            label="Document"
            name="file"
            onChange={(e) => {
              if (e.target.files && e.target.files.length > 0)
                setFileToUpload(e.target.files[0])
            }}
            rules={[
              {
                required: true,
                message: "Document is required!",
              },
            ]}
          >
            <Input
              type="file"
              placeholder="upload file"
              accept="image/jpeg,image/png,application/pdf"
            />
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button
              type="primary"
              htmlType="submit"
              hidden
              id="upload-document"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>}
      {modalLoading && <LoaderComponent tip={'Uploading document'} />}
    </Modal>
  );
}

export default UploadSillaDocument;
